export default import.meta.ROLLUP_FILE_URL_4YuUVQeS1KiaxyruyfIdtQ